import React from 'react'
import { GridElement } from '..'
import { ImageTextList } from '../../components/allComponents'

export const ImageTextListComponent: React.FC<GridElement> = props => {
    return <ImageTextList imageTextList={props.value} />
}
